import { UserLocalOptionsClientInterface } from 'src/common/UserLocalOptionsClient/UserLocalOptionsClientInterface';

export const LIST_DISPLAY_MODE_KEY = 'isListDisplayModeEnabled';

export class UserLocalOptionsClient implements UserLocalOptionsClientInterface {
    private readonly store: LocalForage;

    private isListDisplayModeEnabledValue: boolean = false;

    public constructor(store: LocalForage) {
        this.store = store;
    }

    public async initialize(): Promise<void> {
        try {
            const result = await this.store.getItem(LIST_DISPLAY_MODE_KEY);
            this.isListDisplayModeEnabledValue = result !== null;
        } catch {
            this.isListDisplayModeEnabledValue = false;
        }
    }

    public isListDisplayModeEnabled(): boolean {
        return this.isListDisplayModeEnabledValue;
    }

    public async toggleDisplayMode(): Promise<boolean> {
        const next = !this.isListDisplayModeEnabledValue;
        try {
            if (next) {
                await this.store.setItem(LIST_DISPLAY_MODE_KEY, true);
            } else {
                await this.store.removeItem(LIST_DISPLAY_MODE_KEY);
            }
            this.isListDisplayModeEnabledValue = next;
            return next;
        } catch {
            return this.isListDisplayModeEnabledValue;
        }
    }
}
